import { SEGMENT_CATEGORY_REPORT_ID } from '../../campaigns/modules/campaigns-reports/config/reports/segment-category/segmentCategoryReportId';
import * as ROUTES from './routes';

const { MODULE_NAME } = ROUTES;
const DEFAULT_REPORT = SEGMENT_CATEGORY_REPORT_ID;
const DEFAULT_SEGMENT_ID = -1;

export { MODULE_NAME };
export { DEFAULT_REPORT };
export { DEFAULT_SEGMENT_ID };
export {
    default as SEGMENT_SORTABLE_FIELDS,
    defaultSortField,
    defaultSortType,
    sortFieldsOptions,
} from './segmentSortableFields';
